export default __webpack_public_path__ + "static/media/480_dummy2016-eventagentur01-de.23b9e51d.png";